function initializeGoogleMap() {
    var isMobile = (currentWidth < 768);

    var map = new google.maps.Map(document.getElementById('google_map'), {
        zoom: 14,
        center: {
            lat: 50.729406,
            lng: -3.410201
        },
        scrollwheel: false
    });

    $('.map-overlay-block').on('click', function () {
        $(this).hide();
    });

    var infoBubble2 = new InfoBubble({
        map: map,
        content:
        '<div class="map-bubble-content">' +
        // '<div class="map-bubble-icon">' +
        '<div class="map-bubble-icon" ' + (isMobile ? 'style="width: 140px;"' : '') + '>' +
        // '<img src="/images/logo_white.svg" alt="Homepage">' +
        '<img src="/images/logo_white.svg" alt="Homepage" ' + (isMobile ? 'style="width: 110px;"' : '') + '>' +
        '</div>' +
        '<div class="map-bubble-contacts hidden-xs">' +
        'Unit 4 Silverdown Office Park <span itemprop="streetAddress">Exeter Airport Business Park</span>' +
        '<br>' +
        '<span itemprop="addressLocality">Exeter</span>, <span itemprop="postalCode">EX5 2UX</span>' +
        '<br>' +
        '<span itemprop="addressCountry">United Kingdom</span>' +
        '<div class="bubble-phone">' +
        '<i class="icon-phone"></i>' +
        '<span itemprop="telephone">0333 3051 330</span>' +
        '</div>' +
        '</div>' +
        '</div>',
        position: new google.maps.LatLng(50.729406, -3.410201),
        backgroundColor: '#333',
        borderRadius: 0,
        borderWidth: 0,
        minHeight: 80,
        minWidth: 110,
        maxHeight: 130,
        maxWidth: 385,
        padding: 0,
        hideCloseButton: true,
        arrowPosition: 10,
        backgroundClassName: 'map-bubble-block',
        arrowStyle: 2,
        arrowSize: 26,
        shadowStyle: 0
    });

    infoBubble2.open();
}